import List from './components/List'
import Form from './components/Form'

export default [
  {path: '/institution', component: List, name: 'institution.index'},
  {path: '/institution/store', component: Form, name: 'institution.store'},
  {path: '/institution/:id', component: Form, name: 'institution.update'}
]



// WEBPACK FOOTER //
// ./src/app/domains/institution/routes.js